export default __webpack_public_path__ + "static/media/banner1.00e7e8d3.svg";